<template>
    <div v-if="inputVal">
        <student-worksheet-module-wrapper
            :module="module"
            :module-complete="response.module_complete"
            :worksheet-complete="worksheetComplete"
        >
            <!--            <student-flashcard-review-->
            <!--                :stack="module.content"-->
            <!--                :worksheet-module-mode="true"-->
            <!--                v-on:stack-finished="completeModule()"-->
            <!--            ></student-flashcard-review>-->

            <div
                class="relative mx-auto w-full flex-grow bg-white hover:cursor-pointer md:flex-none"
            >
                <div
                    v-if="stackFinished"
                    class="flex h-48 h-full flex-col items-center justify-center gap-4 md:h-[410px]"
                >
                    <div class="">Deck Finished</div>
                </div>

                <div
                    v-else
                    class="relative flex flex-col justify-between"
                    @click="goForward()"
                >
                    <div
                        class="flex items-center justify-center gap-2 p-4 pb-0 text-[15px] text-gray-625"
                    >
                        <div
                            class="flex flex-grow items-center justify-center gap-2"
                        >
                            <div class="">
                                {{ currentFlashcardIndex + 1 }}
                            </div>
                            <div class="">of</div>
                            <div class="">
                                {{ flashcardStack.flashcards.length }}
                            </div>
                        </div>
                    </div>
                    <!-- card body-->
                    <div
                        class="mb-auto flex h-48 flex-col items-center justify-center text-center text-[21px] leading-loose md:h-[410px]"
                    >
                        <div
                            class="px-4 py-4 text-center md:px-12 lg:px-24"
                            v-if="showingCardFront"
                        >
                            {{ currentFlashcard.front_content }}
                        </div>
                        <div
                            class="px-4 py-4 text-center md:px-12 lg:px-24"
                            v-if="showingCardBack"
                        >
                            {{ currentFlashcard.back_content }}
                        </div>
                    </div>
                    <!-- controls tutorial-->
                    <div class="hidden border-t border-gray-325 md:block">
                        <div
                            class="flex items-center justify-center gap-1 py-4 text-[15px] text-gray-625"
                        >
                            <div class="">
                                Click on card or use the arrows on your keyboard
                            </div>
                            <div class="ml-2 text-gray-500">
                                <svg
                                    width="29"
                                    height="30"
                                    viewBox="0 0 29 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        x="0.5"
                                        y="29"
                                        width="28"
                                        height="28"
                                        rx="3.5"
                                        transform="rotate(-90 0.5 29)"
                                        fill="white"
                                        stroke="currentColor"
                                    />
                                    <path
                                        d="M20.8337 14.5L9.16699 14.5"
                                        stroke="currentColor"
                                        stroke-width="1.66667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M15.0003 20.333L9.16699 14.4997L15.0003 8.66634"
                                        stroke="currentColor"
                                        stroke-width="1.66667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <div class="mr-2 text-gray-500">
                                <svg
                                    width="29"
                                    height="30"
                                    viewBox="0 0 29 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        x="-0.5"
                                        y="-0.5"
                                        width="28"
                                        height="28"
                                        rx="3.5"
                                        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 28 28.5)"
                                        fill="white"
                                        stroke="currentColor"
                                    />
                                    <path
                                        d="M8.16634 14.5L19.833 14.5"
                                        stroke="currentColor"
                                        stroke-width="1.66667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M13.9997 20.333L19.833 14.4997L13.9997 8.66634"
                                        stroke="currentColor"
                                        stroke-width="1.66667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <div class="">to flip</div>
                        </div>
                    </div>
                    <div
                        class="border-t border-gray-325 py-4 text-center text-[15px] text-gray-625 md:hidden"
                    >
                        Click on the card to flip
                    </div>
                </div>
            </div>
        </student-worksheet-module-wrapper>
    </div>
</template>

<script>
import StudentWorksheetModuleWrapper from "./StudentWorksheetModuleWrapper";

export default {
    name: "StudentWorksheetModuleFlashcardStack",
    components: {
        StudentWorksheetModuleWrapper,
    },
    props: ["modelValue", "module", "worksheetComplete"],
    data() {
        return {
            response: {},
            currentFlashcardIndex: 0,
            showingCardFront: true,
            showingCardBack: false,
            stackFinished: false,
            missedCount: 0,
            flashcardStack: this.module.content,
        };
    },
    methods: {
        completeModule() {
            this.inputVal.module_complete = true;
        },
        goToFlashcardsIndex() {
            this.$inertia.get(route("student.flashcards.index"));
        },
        goForward() {
            if (this.showingCardFront) {
                this.showingCardFront = false;
                this.showingCardBack = true;
            } else {
                this.currentFlashcardIndex++;
                if (
                    this.currentFlashcardIndex ===
                    this.flashcardStack.flashcards.length
                ) {
                    this.stackFinished = true;
                    this.completeModule();
                } else {
                    this.showingCardFront = true;
                    this.showingCardBack = false;
                }
            }
        },
        goBack() {
            this.showingCardFront = true;
            this.showingCardBack = false;
        },
    },

    mounted() {
        let vm = this;

        window.addEventListener("keydown", (event) => {
            if (event.key === "ArrowRight") {
                vm.goForward();
            }
            if (event.key === "ArrowLeft") {
                vm.goBack();
            }
        });

        console.log(this.modelValue);

        if (!this.modelValue) {
            this.response = {
                module_complete: false,
            };
        } else {
            this.response = {
                module_complete: this.modelValue.module_complete,
            };

            if (this.modelValue.module_complete) {
                this.stackFinished = true;
            }
        }

        this.inputVal = this.response;
    },
    created() {
    },
    computed: {
        inputVal: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },

        currentFlashcard() {
            return this.flashcardStack.flashcards[this.currentFlashcardIndex];
        },
    },
};
</script>

<style scoped></style>
